import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {
	createTicketingCommentMutation,
	CreateTicketingCommentInput,
} from './__generated__/createTicketingCommentMutation.graphql';

const mutation = graphql`
	mutation createTicketingCommentMutation($input: CreateTicketingCommentInput!) {
		createTicketingComment(input: $input) {
			clientMutationId
			comment {
				id
				type
				author {
					id
					...ticketingPerson_person
				}
				body
				bodyMd
				mentionedUsers {
					id
					...ticketingPerson_person
				}
				createdAt
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: CreateTicketingCommentInput,
	onCompleted?: (r: createTicketingCommentMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<createTicketingCommentMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'createTicketingCommentMutation'};
